$(function() {
    "use strict";
    $(".page-wrapper").delay(5).show();
});